module.exports = __webpack_public_path__ + "img/block_3.7e459475.webp";